'use client';

import ContactUsComponent from '@/components/contact-us/ContactusComponent';
import CTABanner from '../blocks/CTABanner';
import { useTranslation } from '@/hooks/useTranslation';

type Props = {
  locale: string;
};

export default function Contact({ locale }: Props) {
  const { t } = useTranslation(locale);
  return (
    <div>
      <ContactUsComponent locale={locale} />
      <CTABanner
        title={t('Home/ReadyToGetStarted/cta-title')}
        description={t('Home/ReadyToGetStarted/cta-description')}
        cta={t('Home/ReadyToGetStarted/start-trial-aria')}
        ctaTarget="register"
        locale={locale}
      />
    </div>
  );
}
